export const PRICE_ADVISOR = 'Cenový rádce';
export const NEW_AND_SOLD_CARS = 'Přehled nových a prodaných vozidel';
export const RESIDUAL_VALUE = 'Zůstatková hodnota';
